import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

import * as fromModel from '../../services/models';
import { DataService } from '../../services/context/data.service';
import { Subscription } from 'rxjs';
import { UIStateService } from '../../services/context/uistate.service';
import { PlanService } from '../../services/plan.service';


@Component({
  selector: 'gp-delete-plan',
  templateUrl: './delete-plan.component.html',
  styleUrls: ['./delete-plan.component.scss']
})
export class DeletePlanComponent implements OnInit, OnDestroy {

  errorMsg: string;
  isDataAvailable: boolean = false;  
  planId: string;
  planName: string;

  protected _storeDataSubscription: Subscription;  


  constructor(private dataService: DataService, 
    private planService: PlanService,
    private uiStateService: UIStateService,
    private dialogRef: MatDialogRef<DeletePlanComponent>,
    @Inject(MAT_DIALOG_DATA) private inputData: any) { 
      this.planId = inputData.planId;
      this.planName = inputData.planName;
    }

    ngOnInit(): void {
    }


  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }
  }

  closeDialog(): void {
    this.dialogRef.close();    
  } 

  private showErrorMsg(msg){
    this.errorMsg = msg;
  }

  deletePlan(){
    this.planService.deletePlan(this.planId).subscribe(data => {      
      this.dialogRef.close(true);  
    }, err => {
      this.showErrorMsg("Error deleting plan.")
      console.log("Error while deleting Plan: DeletePlanComponent - deletePlan:" + JSON.stringify(err));      
    });
  }


}
